import { IGetTeaserInfo, ICreateTeaser, IUpdateTeaser, IGetPaginatedTeasers, ITeasers } from 'types';
import { AxiosResponse } from 'axios';
import { request } from '../index';

const serviceGetTeaserInfo = (teaserID: string): Promise<IGetTeaserInfo> => {
	return request({ typeOfRequest: 'getWithToken', url: `/api/Screensavers/${teaserID}` });
};

const serviceCreateTeaser = (data: ICreateTeaser): Promise<AxiosResponse<void>> => {
	return request({ typeOfRequest: 'postWithToken', url: `/api/Screensavers`, data });
};

const serviceUpdateTeaser = (data: IUpdateTeaser): Promise<AxiosResponse<void>> => {
	return request({ typeOfRequest: 'putWithToken', url: `/api/Screensavers/${data.id}`, data });
};

const serviceGetPaginatedTeasers = (args: IGetPaginatedTeasers): Promise<AxiosResponse<ITeasers>> => {
	return request({ typeOfRequest: 'postWithToken', url: `/api/Screensavers/filtered`, data: args });
};

const serviceDeleteTeaser = (teaserID: string): Promise<AxiosResponse<void>> => {
	return request({ typeOfRequest: 'deleteWithTokenAndWithParameterInUrlLine', url: `/api/Screensavers/${teaserID}` });
};

export {
	serviceGetTeaserInfo,
	serviceCreateTeaser,
	serviceUpdateTeaser,
	serviceGetPaginatedTeasers,
	serviceDeleteTeaser,
};
